import React from 'react';
import Breadcrumb from '../components/common/Breadcrumb';

const PrivacyPolicyPage = () => {
  return (
    <div className="bg-white min-h-screen py-8">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="border-b pb-4 mb-8">
          <Breadcrumb items={[{ label: 'Home', path: '/' }, { label: 'Privacy Policy', path: '/privacy-policy' }]} />
        </div>
        <h1 className="text-3xl font-light text-center text-gray-900 mb-8 tracking-wide">Privacy Policy</h1>
        <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
          <p>Last Updated: June 15, 2026</p>
          <p>At ArshiVastra, we are committed to protecting your privacy. This policy outlines how we collect, use, and safeguard your personal information.</p>
          <p><strong>Information We Collect:</strong> We collect information you provide directly, such as your name, email address, phone number, and shipping address.</p>
          <p><strong>How We Use Information:</strong> We use your information to process orders, provide customer service, send marketing communications, and improve your shopping experience.</p>
          <p><strong>Data Security:</strong> We implement industry-standard security measures to protect your personal data.</p>
          <p><strong>Contact Us:</strong> If you have questions about this Privacy Policy, please contact our support team.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;